import React from "react";
import { Footer, Navbar } from "../components";
const AboutPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">About ChipsetRC</h1>
        <hr />
        <p className="lead text-center">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Unde
          suscipit distinctio voluptates in quod nesciunt consectetur harum
          accusantium quasi excepturi, nobis nostrum fugiat necessitatibus porro
          quam! Aut fuga quia illo molestias. Tempora id quasi deleniti harum
          perspiciatis corrupti ipsa veritatis quos, omnis perferendis adipisci
          velit in iure incidunt debitis voluptate magnam minima eaque commodi.
          At provident consequatur debitis velit ex natus deserunt nostrum non
          beatae quos voluptatem repudiandae repellendus facilis vel iure
          aspernatur neque consequuntur dignissimos, in maiores odio laboriosam
          aut. Rem accusantium asperiores voluptas ipsam similique nulla
          voluptatum nam, ea eos repudiandae doloribus laborum et voluptates
          dolorem. Exercitationem sapiente ullam rerum beatae laborum. Quis iste
          magnam dolorum doloremque itaque sint voluptate suscipit fugit
          accusantium similique architecto deserunt velit eius possimus, numquam
          provident ratione sunt cum? Nobis recusandae saepe commodi nisi quam,
          dolore aperiam inventore modi ullam, necessitatibus ducimus magnam est
          vitae illum eum sequi accusantium distinctio dolor nostrum doloremque
          soluta fugit. Mollitia, veniam rem iusto consequuntur eligendi nemo
          molestiae quod dolor sequi blanditiis quaerat maxime earum recusandae,
          nostrum id velit saepe alias. Odio laudantium iste unde, magni
          explicabo, rem, soluta vel temporibus et sint quasi. Veritatis, quos
          ab, mollitia ipsum similique blanditiis corporis optio est voluptates
          facere eos non?
        </p>
        {/* <p className="lead text-center">
          Hi, I’m Tintin, and I started this small business during lockdown when
          I finally had the time to turn an idea into reality. As an Radio
          Control enthusiast, I was always frustrated by how hard it was to find
          good plug-and-play electronic units for lighting and other functions.
          So, I decided to make my own.{" "}
        </p>
        <p className="lead text-center">
          With a master’s degree in electronic engineering and a love for
          tinkering, I designed these units to be simple, reliable, and easy to
          use. They connect directly to receivers for RC trucks, cars, and
          boats, or plug right into model railways—no fuss, no complicated
          setups. Now, I get to share these solutions with others who love the
          hobby as much as I do. Whether you’re just starting out or have been
          at it for years, I hope my products make things a little easier and a
          lot more fun.
        </p> */}
        <p className="lead text-center">
          Thanks for stopping by and supporting my small business!
        </p>

        <h2 className="text-center py-4">Our Products</h2>
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img
                className="card-img-top img-fluid"
                src="images/Product1.avif"
                alt=""
                height={160}
              />
              <div className="card-body">
                <h5 className="card-title text-center">RC C/T</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img
                className="card-img-top img-fluid"
                src="images/Product2.webp"
                alt=""
                height={160}
              />
              <div className="card-body">
                <h5 className="card-title text-center">RCB</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img
                className="card-img-top img-fluid"
                src="/images/Product3.jpg"
                alt=""
                height={160}
              />
              <div className="card-body">
                <h5 className="card-title text-center">MR</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img
                className="card-img-top img-fluid"
                src="/images/Product4.webp"
                alt=""
                height={160}
              />
              <div className="card-body">
                <h5 className="card-title text-center">Ele</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AboutPage;
